export default "__VITE_ASSET__G4ElLCi___"